import React from 'react';
import { Grid } from 'semantic-ui-react';
import Image from '../../../atoms/Image';
import { ImagePropType } from '../../../services/proptypes';
import { getImageKey } from '../../../utils/images';
var ImageRow = function ImageRow(_ref) {
  var imageGroup = _ref.imageGroup;
  return /*#__PURE__*/React.createElement(Grid.Row, {
    columns: imageGroup.length,
    style: {
      padding: '0'
    }
  }, imageGroup.map(function (image) {
    return /*#__PURE__*/React.createElement(Grid.Column, {
      key: getImageKey(image),
      style: {
        padding: '0.3em'
      }
    }, /*#__PURE__*/React.createElement(Image, {
      background: true,
      src: image,
      style: {
        paddingTop: '100%',
        height: '100%'
      }
    }));
  }));
};
export default ImageRow;